import FilterChips from '@/client/components/FilterChips/FilterChips';

export default FilterChips;
